const d3 = Object.assign(
    {},
    require("d3-array"),
    require("d3-selection"),
    require("d3-fetch"),
    require("d3-transition"),
    require("d3-ease"),
    require("d3-scale")
)
import "lodash"
import { getDimensions, getColors } from "./d3-tag-dimensions"
import drawBase from "./d3-tag-drawBase"
import prepareData from "./d3-tag-data"
import {
    drawContent,
    updateContent,
    removeTagHighlight,
    hideToolTip,
    setTag
} from "./d3-tag-drawContent"
import { createBrush, resizeBrush } from "./d3-tag-brush"

export default class TagViz {
    constructor(DOMtarget, topTags) {
        this.DOMtarget = DOMtarget
        this.dataset = null
        this.localStorage = null

        // root
        this.wrapper = null

        // Dimensions
        this.dimensions = getDimensions(this.DOMtarget)
        this.colors = getColors()

        // Accessors
        this.dataAccessor = d => d.tag

        // Settings
        this.minCount = 20 // number of times the keyword must be in dataset
        this.maxTagsPerPhoto = 7 // Number of tags to inlcude ut of 20 available tags per photo

        // Transitions
        this.trans = d3
            .transition()
            .duration(2000)
            .ease(d3.easeLinear)

        // Data
        if (localStorage.getItem("d3_tag") === null) {
            this.startIndex = 0
            this.topTags = topTags
        } else {
            let locStorage = JSON.parse(localStorage.getItem("d3_tag"))
            this.startIndex = locStorage.settings.startIndex
            this.topTags = locStorage.settings.topTags
        }
        this.tagArray = []

        this.tagCount = 0
        this.matrix = []
        this.selectedTags = []
        this.tagAmount = []
        this.tagAll = []
        this.selectedTagName = ""

        // States
        this.tagClicked = -1
        this.brushTimerId = -1

        // Scales
        this.brushArea = null
        this.brushPoint = null
    }

    async loadData(fileName) {
        const theDataSet = await d3.json(`/data/${fileName}.json`)
        console.log(`This dataset contains ${theDataSet.length} photos`)
        this.dataset = theDataSet
        return theDataSet
    }

    init() {
        if (localStorage.getItem("d3_tag") === null) {
            const locStorage = {}
            locStorage.settings = {}
            locStorage.settings.topTags = this.topTags
            locStorage.settings.startIndex = this.startIndex
            window.localStorage.setItem("d3_tag", JSON.stringify(locStorage))
        }
        this.prepareData()
    }

    updateTags(topTags) {
        this.topTags = topTags

        let locStorage = JSON.parse(localStorage.getItem("d3_tag"))
        locStorage.settings.topTags = topTags
        window.localStorage.setItem("d3_tag", JSON.stringify(locStorage))

        this.prepareData()
        this.resizeBrush()
        this.updateContent()
    }

    resize() {
        this.dimensions = getDimensions(this.DOMtarget)
        this.init()
        this.drawBase()
        this.drawContent(this.data)
    }
}

Object.assign(TagViz.prototype, {
    prepareData,
    drawBase,
    drawContent,
    updateContent,
    removeTagHighlight,
    hideToolTip,
    setTag,
    createBrush,
    resizeBrush
})
